import screenshotImg from "../../../assets/Screenshot 2026-07-14 134645.png";

function HeroFooter() {
  return (
    <div className="w-full mt-10 md:mt-0 md:-translate-y-16 mb-0 md:mb-5">
      <div className="project-container">
        <img
          src={screenshotImg}
          alt="Jobdaten Dashboard"
          className="w-full rounded-2xl shadow-2xl border border-gray-200"
        />
      </div>
    </div>
  );
}

export default HeroFooter;
